import { FreefieldCategoryWithValues } from "shared/utils/freeFields/models";
import ReadonlyFreefieldValue from "components/Freefields/Readonly/ReadonlyFreefieldValue";
import { FormSection } from "components/MainSectionTemplate/types";
import React from "react";

export const freeFieldsForWebformSections = (
  freeFieldCategoriesWithValues: FreefieldCategoryWithValues[],
  freeFieldsInWebform: server.dto.FreeFieldForWebform[],
): Array<FormSection> => {
  const freeFieldsInWebformIdsSet = new Set(freeFieldsInWebform.map(ff => ff.freeFieldDefinitionId));

  return freeFieldCategoriesWithValues
    .filter(category => category.definitionWithValues.some(def => freeFieldsInWebformIdsSet.has(def.freeFieldDefinitionId)))
    .map(category => ({
      key: `${category.freeFieldCategoryId}`,
      type: "collapsable",
      title: category.title,
      fields: category.definitionWithValues
        .filter(def => freeFieldsInWebformIdsSet.has(def.freeFieldDefinitionId))
        .map(defWithValue => ({
          key: `${defWithValue.freeFieldDefinitionId}`,
          label: defWithValue.title,
          isEmpty: !defWithValue.displayValue.hasVisibleValue,
          sublabel: defWithValue.description,
          render: () => <ReadonlyFreefieldValue
            type={defWithValue.type}
            displayValue={defWithValue.displayValue}
          />
        })),
    }))
}